import { render, staticRenderFns } from "./DashboardAgencyItem.vue?vue&type=template&id=8faa696e&"
import script from "./DashboardAgencyItem.vue?vue&type=script&lang=js&"
export * from "./DashboardAgencyItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports